module.exports = __webpack_public_path__ + "static/media/customer-midas.fd3e58e3.png";